import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  z-index: 999999;
  background-color: rgba(256, 256, 256, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
`;
export const Box = styled.div`
  background-color: ${Variables.colors.complementary};
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.2);
  width: 472.5px;
  padding: 16px 0;
  min-height: 200px;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow-y: auto;
  span {
    color: ${Variables.colors.complementary_900};
    font-size: ${Variables.font_sizes.x2_medium};
    margin-bottom: 26px;
    display: block;
    padding: 8px;
  }
  .download-box {
    padding: 0 16px;

    .download-modal-title {
      color: ${Variables.colors.complementary_900};
      font-size: ${Variables.font_sizes.x2_medium};
      margin-bottom: 18px;
      padding: 8px;
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      animation: fadeIn 1s;
      opacity: ${props => (props.redisplay ? "1" : "0")};
      @keyframes fadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
      li {
        color: ${Variables.colors.complementary_700};
        border-radius: 4px;
        cursor: pointer;
        padding: 8px;
        display: flex;
        align-items: center;

        i {
          font-size: ${Variables.font_sizes.x2_large};
          margin-left: 6px;
        }

        .premium-icon {
          display: flex;
          margin-right: 8px;

          &:before {
            color: ${Variables.colors.yellow_500};
            font-size: 16px;
          }
        }

        &:hover {
          background-color: ${Variables.colors.primary_50};
          color: ${Variables.colors.primary_vivid};
        }
      }

      & > div:last-child {
        margin-top: 10px;
        border-top: 1px solid ${Variables.colors.complementary_400};
        & > button {
          float: left;
          color: ${Variables.colors.primary_vivid};
        }
      }
    }
  }
`;
export const DateBox = styled.div`
  display: ${props => (props.status ? "block" : "none")};
  padding: 8px;
  margin: 8px 0;

  .text {
    width: 80%;
    font-size: ${Variables.font_sizes.x_small};
    color: ${Variables.colors.complementary_600};
    margin: 8px 0;
    padding: 0 8px;
    line-height: 1.58;
  }

  .top-box {
    .first-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 42px;
      & > div:last-child {
        width: auto;
        position: unset;
      }
    }

    span {
      font-size: ${Variables.font_sizes.medium};
      color: ${Variables.colors.complementary_600};
      font-weight: 500;
      margin-bottom: 0;
    }
    .text {
      width: 80%;
      font-size: ${Variables.font_sizes.x_small};
      color: ${Variables.colors.complementary_600};
      margin: 16px 0;
      line-height: 1.58;
    }
    button {
      background-color: ${Variables.colors.complementary_200};
      display: flex;
      justify-content: flex-end;
      width: auto;
      height: auto;
    }
    .calendar-icon {
      display: none;
    }
  }
`;
